import { getTenantId } from './token.js';
import { isPlatformAdmin } from './permissions.js';

const STORAGE_KEY = 'platformViewTenantId';
export const PLATFORM_VIEW_TENANT_EVENT = 'platform-view-tenant-change';

export function getPlatformViewTenantId() {
  if (!isPlatformAdmin()) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw && raw.trim() && raw !== 'undefined' && raw !== 'null') {
      return raw.trim();
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function setPlatformViewTenantId(tenantId) {
  try {
    const next = tenantId && String(tenantId).trim() ? String(tenantId).trim() : '';
    const prev = getPlatformViewTenantId() || '';
    // 值未变时不写 storage、不派发事件，避免列表按钮误触发整页租户同步
    if (next === prev) return;
    if (next) {
      sessionStorage.setItem(STORAGE_KEY, next);
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
    window.dispatchEvent(
      new CustomEvent(PLATFORM_VIEW_TENANT_EVENT, {
        detail: next || null
      })
    );
  } catch {
    /* ignore */
  }
}

/** 业务数据租户：平台管理员优先用切换租户，否则 JWT 租户 */
export function resolveDataTenantId(fallback = 'default') {
  const view = getPlatformViewTenantId();
  if (view) return view;
  return getTenantId(fallback);
}
